import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { PostCategoriesTable } from '@app/components/apps/PostCategories/PostCategoryTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

const AllPostCategories: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, removeHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-post-category');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/post-categories', breadcrumbName: 'Post Categories' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Post Category',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Post Categories</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PostCategoriesTable />
        </Col>
      </Row>
    </>
  );
};

export default AllPostCategories;
